import axios from 'axios';

// Create axios instance
const apiClient = axios.create();

// Request interceptor to add authentication headers and base URL
apiClient.interceptors.request.use(
    (config) => {
        // Set base URL dynamically if not already set
        if (!config.baseURL && window.GENESIS_CMS_API_URL) {
            config.baseURL = window.GENESIS_CMS_API_URL;
        }
        
        // Skip authentication if skipAuth flag is set
        if (config.skipAuth) {
            delete config.skipAuth;
            return config;
        }
        
        // Get token and session ID
        const token = window.genesisToken ? window.genesisToken() : localStorage.getItem('AuthToken');
        const sessionId = localStorage.getItem('SessionId');

        // Add authentication headers if token exists
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        // Add session ID header if it exists
        if (sessionId) {
            config.headers['X-Session-Id'] = sessionId;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for global error handling (optional)
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle common errors here if needed
        // For example, redirect to login on 401
        if (error.response && error.response.status === 401) {
            // Handle unauthorized access
            console.log('Unauthorized access - consider redirecting to login');
        }
        
        return Promise.reject(error);
    }
);

export default apiClient;

// Export a method to create requests without authentication (for public endpoints)
export const createUnauthenticatedRequest = (config) => {
    return axios(config);
};

// Export a method to skip authentication for specific requests
export const skipAuth = (config) => {
    return apiClient({
        ...config,
        skipAuth: true
    });
};
